import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { Clients } from '../components/Clients';
import { Team } from '../components/Team';
import { FAQ } from '../components/FAQ';
import { CTASection } from '../components/CTASection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50" data-id="element-181">
      <Navbar data-id="element-182" />
      <Hero data-id="element-183" />
      <Services data-id="element-184" />
      <Process data-id="element-185" />
      <Clients data-id="element-186" />
      <Team data-id="element-187" />
      <FAQ data-id="element-188" />
      <CTASection data-id="element-189" />
      <ContactForm data-id="element-190" />
      <Footer data-id="element-191" />
    </div>;
}